export default __webpack_public_path__ + "static/media/owner.c95d688a.svg";